import i18n from "../../configs/i18n";

export const translate = (key, value) => i18n.t(key, value);
